import { genComponentStyleHook, type FullToken } from './styleUtil'
import { background } from './gradientUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Divider', 'techTheme'], (token: FullToken) => {
  const { componentCls, lineWidth } = token
  return {
    [`${DOT_PREFIX}${componentCls}`]: {
      [`&${componentCls}-horizontal`]: {
        border: 'none',
        height: lineWidth,
        background,
      },
    },
  }
})
